/**
 * @author Michael Oppitz
 */
let THREE = require('../../../../externals/three');
let Shaders = require('../shaders/ShaderFile');

THREE.ShapeDiverGemMaterial = function (parameters) {
  THREE.MeshStandardMaterial.call(this);

  this.defines = {
    STANDARD: ''
  };

  this.uniforms = THREE.UniformsUtils.merge([
    THREE.UniformsLib.common,
    THREE.UniformsLib.envmap,
    THREE.UniformsLib.aomap,
    THREE.UniformsLib.lightmap,
    THREE.UniformsLib.bumpmap,
    THREE.UniformsLib.normalmap,
    THREE.UniformsLib.displacementmap,
    THREE.UniformsLib.roughnessmap,
    THREE.UniformsLib.metalnessmap,
    THREE.UniformsLib.lights,
    {
      emissive: { value: new THREE.Color(0x000000) },
      roughness: { value: 0.5 },
      metalness: { value: 0 },
      envMapIntensity: { value: 1 }, // temporary
    },
    {
      contrast: { value: 1.0 },
      directSpecularContrast: { value: 1.0 },
      indirectSpecularContrast: { value: 1.0 },
      directSpecularIntensity: { value: 1.0 },
      indirectSpecularIntensity: { value: 1.0 },
      reflectionNormalMap: { value: null},
      reflectionNormalMapIntensity: { value: 1.0},
      reflectionNormalMapRepeat: { value: 1.0},
      dispersionMap: { value: null},
      dispersionMapIntensity: { value: 1.0},
      dispersionMapRepeat: { value: 1.0},
      reflectionMap: { value: null},
      reflectionMapIntensity: { value: 1.0},
      reflectionMapContrast: { value: 1.0 },
      reflectionMapRepeat: { value: 1.0},
      reflectionMapColor: { value: new THREE.Color(0xffffff) },
    }
  ]);

  if(parameters) {
    if(parameters.side === THREE.FrontSide) {
      this.color = parameters.colorFront;
      this.opacity = parameters.opacityFront;
      this.metalness = parameters.metalnessFront;
      this.roughness = parameters.roughnessFront;

      
      this.uniforms.reflectionMap.value = parameters.reflectionMapFront;
      this.reflectionMap = parameters.reflectionMapFront;
      this.uniforms.reflectionMapIntensity.value = parameters.reflectionMapIntensityFront;
      this.reflectionMapIntensity = parameters.reflectionMapIntensityFront;
      this.uniforms.reflectionMapContrast.value = parameters.reflectionMapContrastFront;
      this.reflectionMapContrast = parameters.reflectionMapContrastFront;
      this.uniforms.reflectionMapRepeat.value = parameters.reflectionMapRepeatFront;
      this.reflectionMapRepeat = parameters.reflectionMapRepeatFront;
      this.uniforms.reflectionMapColor.value = parameters.reflectionMapColorFront;
      this.reflectionMapColor = parameters.reflectionMapColorFront;
    } else {
      this.color = parameters.colorBack;
      this.opacity = parameters.opacityBack;
      this.metalness = parameters.metalnessBack;
      this.roughness = parameters.roughnessBack;

      
      this.uniforms.reflectionMap.value = parameters.reflectionMapBack;
      this.reflectionMap = parameters.reflectionMapBack;
      this.uniforms.reflectionMapIntensity.value = parameters.reflectionMapIntensityBack;
      this.reflectionMapIntensity = parameters.reflectionMapIntensityBack;
      this.uniforms.reflectionMapContrast.value = parameters.reflectionMapContrastBack;
      this.reflectionMapContrast = parameters.reflectionMapContrastBack;
      this.uniforms.reflectionMapRepeat.value = parameters.reflectionMapRepeatBack;
      this.reflectionMapRepeat = parameters.reflectionMapRepeatBack;
      this.uniforms.reflectionMapColor.value = parameters.reflectionMapColorBack;
      this.reflectionMapColor = parameters.reflectionMapColorBack;
    }

    this.uniforms.contrast.value = parameters.contrast;
    this.contrast = parameters.contrast;
    this.uniforms.indirectSpecularIntensity.value = parameters.indirectSpecularIntensity;
    this.indirectSpecularIntensity = parameters.indirectSpecularIntensity;
    this.uniforms.directSpecularIntensity.value = parameters.directSpecularIntensity;
    this.directSpecularIntensity = parameters.directSpecularIntensity;
    this.uniforms.directSpecularContrast.value = parameters.directSpecularContrast;
    this.directSpecularContrast = parameters.directSpecularContrast;
    this.uniforms.indirectSpecularContrast.value = parameters.indirectSpecularContrast;
    this.indirectSpecularContrast = parameters.indirectSpecularContrast;



    this.uniforms.reflectionNormalMap.value = parameters.reflectionNormalMap;
    this.reflectionNormalMap = parameters.reflectionNormalMap;
    this.uniforms.reflectionNormalMapIntensity.value = parameters.reflectionNormalMapIntensity;
    this.reflectionNormalMapIntensity = parameters.reflectionNormalMapIntensity;
    this.uniforms.reflectionNormalMapRepeat.value = parameters.reflectionNormalMapRepeat;
    this.reflectionNormalMapRepeat = parameters.reflectionNormalMapRepeat;

    this.uniforms.dispersionMap.value = parameters.dispersionMap;
    this.dispersionMap = parameters.dispersionMap;
    this.uniforms.dispersionMapIntensity.value = parameters.dispersionMapIntensity;
    this.dispersionMapIntensity = parameters.dispersionMapIntensity;
    this.uniforms.dispersionMapRepeat.value = parameters.dispersionMapRepeat;
    this.dispersionMapRepeat = parameters.dispersionMapRepeat;

    delete parameters.materialType;
    delete parameters.contrast;
    delete parameters.indirectSpecularIntensity;
    delete parameters.directSpecularIntensity;
    delete parameters.directSpecularContrast;
    delete parameters.indirectSpecularContrast;
    delete parameters.colorFront;
    delete parameters.opacityFront;
    delete parameters.metalnessFront;
    delete parameters.roughnessFront;
    delete parameters.colorBack;
    delete parameters.opacityBack;
    delete parameters.metalnessBack;
    delete parameters.roughnessBack;

    delete parameters.reflectionMapFront;
    delete parameters.reflectionMapIntensityFront;
    delete parameters.reflectionMapContrastFront;
    delete parameters.reflectionMapRepeatFront;
    delete parameters.reflectionMapColorFront;
    delete parameters.reflectionMapBack;
    delete parameters.reflectionMapIntensityBack;
    delete parameters.reflectionMapContrastBack;
    delete parameters.reflectionMapRepeatBack;
    delete parameters.reflectionMapColorBack;

    delete parameters.reflectionNormalMap;
    delete parameters.reflectionNormalMapIntensity;
    delete parameters.reflectionNormalMapRepeat;
    delete parameters.dispersionMap;
    delete parameters.dispersionMapIntensity;
    delete parameters.dispersionMapRepeat;

    delete parameters.renderAO;
  }

  this.vertexShader = Shaders.gem_vert;
  this.fragmentShader = Shaders.gem_frag;
  this.type = 'ShapeDiverGemMaterial';

  this.needsUpdate = false;
  this.setValues(parameters);
};

THREE.ShapeDiverGemMaterial.prototype = Object.create(THREE.MeshStandardMaterial.prototype);
THREE.ShapeDiverGemMaterial.prototype.constructor = THREE.ShapeDiverGemMaterial;
THREE.ShapeDiverGemMaterial.prototype.isMeshStandardMaterial = true;

THREE.ShapeDiverGemMaterial.prototype.copy = function (source) {
  THREE.MeshStandardMaterial.prototype.copy.call(this, source);
  this.defines = source.defines;
  this.uniforms = THREE.UniformsUtils.clone(source.uniforms);
  this.type = source.type;
  return this;
};

THREE.ShapeDiverGemMaterial.prototype.deepCopy = function (source) {
  THREE.MeshStandardMaterial.prototype.copy.call(this, source);
  this.defines = Object.assign({}, source.defines);
  this.uniforms = THREE.UniformsUtils.clone(source.uniforms);
  this.type = source.type;
  return this;
};
